import React from 'react';
import './Hero.css';

const tickerItems = [
  'SEO & SEM', 'Social Media', 'Paid Ads', 'Content Marketing',
  'Web Design', 'Email Campaigns', 'Brand Strategy', 'Analytics',
];

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__noise" aria-hidden="true"></div>
      <div className="hero__grid" aria-hidden="true"></div>

      <div className="hero__content">
        <p className="hero__eyebrow">
          A Social Media Marketing Agency taking brands...
        </p>

        <h1 className="hero__headline">
          <span className="line line--white">From Invisible</span>
          <span className="line line--accent">to Unmissable</span>
        </h1>

        <p className="hero__subtext">Scale with BeyonDigital</p>

        <p className="hero__sub">
          We don't just market brands — we engineer visibility,
          attention and growth in the digital age.
        </p>

        <div className="hero__actions">
          <a href="#contact" className="btn btn--primary">Get Started</a>
          <a href="#services" className="btn btn--ghost">View Our Work</a>
        </div>
      </div>

      <div className="hero__ticker" aria-hidden="true">
        <div className="ticker__track">
          {[...tickerItems, ...tickerItems, ...tickerItems].map((item, i) => (
            <React.Fragment key={i}>
              <span>{item}</span>
              <span className="dot">✦</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}